import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Edit } from '@mui/icons-material';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { PersonSearchStorageVM } from 'shell/view-models/search-anpr';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const ActionsList = ({ cell, filterPersonForm }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();

  const personFilterTable = useFilterTable<PersonSearchStorageVM>();

  const getPerson = useHttpClient(`${__PERSON_API_URL__}/ricerca-persona/registrazione-vedovanza`, {
    options: {
      loading: true,
      errorCatching: true,
      method: 'POST',
    },
  });

  const onEditPress = useEventCallback(() => {
    return new Promise((resolve) => {
      (
        getPerson({
          data: {
            criteriRicerca: {
              idSchedaSoggettoANPR: cell?.anpr,
              codiceFiscale: cell?.fiscalCode || undefined,
            },
            datiRichiesta: {
              ricercaNazionale:
                filterPersonForm?.commonSearch?.isNationalResearch ||
                filterPersonForm?.subjectData?.isNationalResearch
                  ? '1'
                  : '0',
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        personFilterTable.setValues({ subject: cell, filters: filterPersonForm });

        navigate({
          pathname: '/mutazioni/persona/vedovanza/registrazione',
          search: `?${createSearchParams({
            ricercaNazionale:
              filterPersonForm?.commonSearch?.isNationalResearch?.toString() ||
              filterPersonForm?.subjectData?.isNationalResearch?.toString() ||
              'false',
            codiceFiscale: cell?.fiscalCode || '',
            idSchedaSoggettoANPR: cell?.anpr || '',
            idFamigliaANPR: cell?.idFamilyAnpr || '',
            idSchedaSoggettoComune: cell?.idSchedaSoggettoComune?.idSchedaSoggetto || '',
            codicePersonaSipo: cell?.codicePersonaSipo || '',
          })}`,
        });
        resolve(cell);
      });
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onEditPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <Edit />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list Document - registration widowhood page component';

export default ActionsList;
